export default "__VITE_ASSET__ozb0u$x___"